<app-dialog [size]="DialogSize.EXTRA_LARGE">
  <app-dialog-header>Manage Blocked Emails</app-dialog-header>

  @if (errorMessage()) {
    <div class="alert alert--error" dataSelector="manage-blocked-emails-error">
      <p class="body-300">{{ errorMessage() }}</p>
    </div>
  }

  <div class="d-flex flex-column gap-4">
    <div class="blocked-emails-toolbar">
      @if (canEdit()) {
        <button
          andButton
          color="default"
          dataSelector="manage-blocked-emails-add-email-button"
          [disabled]="isSubmitting()"
          (click)="addEmail()"
        >
          + Add Email
        </button>
      }
      <input
        class="form-input form-input--search blocked-emails-search"
        type="text"
        placeholder="Search by email address"
        dataSelector="manage-blocked-emails-search"
        [formControl]="searchControl"
      />
    </div>

    <ag-grid-angular
      class="ag-theme-material blocked-emails-grid"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      dataSelector="manage-blocked-emails-grid"
      (gridReady)="onGridReady($event)"
    />

    <ng-template #actionsCellTemplate let-row>
      <div
        [tooltip]="
          !canEdit() && 'You do not have permissions to edit blocked emails.'
          || row.data.pendingRemoval && 'Undo'
          || 'Remove'
        "
      >
        @if (row.data.pendingRemoval) {
          <button
            andButton
            color="ghost"
            size="small"
            dataSelector="manage-blocked-emails-undo-button"
            class="mx-auto"
            [disabled]="isSubmitting()"
            (click)="undoRemove(row.data)"
          >
            <anduin-icon name="refresh-ccw" />
          </button>
        } @else {
          <button
            andButton
            color="ghost-negative"
            size="small"
            dataSelector="manage-blocked-emails-remove-button"
            class="mx-auto"
            [disabled]="isSubmitting()"
            (click)="removeRow(row.data)"
          >
            <anduin-icon name="trash-2" />
          </button>
        }
      </div>
    </ng-template>
  </div>

  <app-dialog-footer customCancelLabel="Close">
    <button
      andButton
      color="primary"
      dataSelector="manage-blocked-emails-save-button"
      [disabled]="!canEdit() || isSubmitting() || !hasChanges()"
      [isLoading]="isSubmitting()"
      tooltip="You do not have permissions to edit blocked emails."
      [tooltipEnabled]="!canEdit()"
      (click)="save()"
    >
      Save Changes
    </button>
  </app-dialog-footer>
</app-dialog>
